module.exports = __webpack_public_path__ + "static/img/v4_4.82169ccd.png";